import { render, staticRenderFns } from "./ReceiverList.vue?vue&type=template&id=6edaad9c&"
import script from "./ReceiverList.vue?vue&type=script&lang=js&"
export * from "./ReceiverList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports